import { inject, Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { DatabaseModelService } from '../../services/database-model/database-model.service';
import { catchError, first, map, Observable, of, switchMap, take } from 'rxjs';
import { FIRST_OF_OBSERVABLE } from '../../models/constant/constants.constant';

@Injectable({ providedIn: 'root' })
export class LinkAlreadyExistsValidator implements AsyncValidator {
  databaseModelService: DatabaseModelService = inject(DatabaseModelService);

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    const table1 = control.get('table1')?.value;
    const table2 = control.get('table2')?.value;

    return control.events.pipe(
      take(FIRST_OF_OBSERVABLE),
      switchMap(() =>
        this.databaseModelService.linkExist$(table1, table2).pipe(
          map(exists => (exists ? { linkExists: `Il y a déjà un lien ${table1} - ${table2}.` } : null)),
          catchError((error: Error) => of({ linkExists: error.message })),
          first()
        )
      )
    );
  }
}
